module.exports = __webpack_public_path__ + "static/media/info.200198c2.svg";